import React from "react";

/**
 * InfraVest mark
 * Geometric stack of beams (cell tower) merging into an upward
 * orange→yellow signal. Designed to read at 24px and 200px.
 */
export const InfraVestLogo = ({ size = 28, withWordmark = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="infravest-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="gv-grad" x1="0" y1="40" x2="40" y2="0" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#f97316" />
            <stop offset="100%" stopColor="#eab308" />
          </linearGradient>
        </defs>
        {/* outer tower frame */}
        <path
          d="M6 36 L20 4 L34 36"
          stroke="url(#gv-grad)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* cross beams */}
        <path d="M11 24 L29 24" stroke="#ffffff" strokeOpacity="0.9" strokeWidth="2" strokeLinecap="round" />
        <path d="M14 18 L26 18" stroke="#ffffff" strokeOpacity="0.7" strokeWidth="2" strokeLinecap="round" />
        <path d="M17 12 L23 12" stroke="#ffffff" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" />
        {/* signal pulse */}
        <circle cx="20" cy="6" r="2.5" fill="#eab308" />
      </svg>
      {withWordmark && (
        <span className="font-display text-lg font-semibold tracking-tight text-white">
          Infra<span className="text-orange-500">Vest</span>
        </span>
      )}
    </div>
  );
};

export default InfraVestLogo;
